import React from 'react';
import { useSelector } from 'react-redux';

import { Select, Input, InputNumber, Space } from 'antd';

import FileUpload from '../../../../../../../components/FileUpload';
import { getAsNumber } from '../../../../../../../utilities/numberConvertion';
import AttachmentImageViewModal from '../../../../../../../components/Modal/AttachmentImageViewModal';

const getOptions = (list) => {
  return list?.map((item) => ({
    value: item?.value,
    label: <div>{item?.label}</div>,
    credit: item.credit
  }));
};

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { course_type: courseType } = staticData;

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: 'Course',
      render: (value, row) => {

        const _courseType = courseType?.length > 0 ? courseType?.filter((item) => item.value === Number(value)) : [];
        const _course = _courseType.length ? _courseType[0] : {};

        const { value: courseValue } = _course;

        return courseType?.length ? (
          <Select
            style={{ width: '140px' }}
            options={getOptions(courseType)}
            defaultValue={courseValue}
            placeholder="Select a Course"
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e, selected) => {
              action({
                ...row,
                name: e,
                credit: selected.credit
              });
            }}
          />
        ) : (
          <></>
        );
      }
    },
    {
      key: 'credit',
      dataIndex: 'credit',
      title: 'Credits'
    },

    {
      key: 'course_name',
      dataIndex: 'course_name',
      title: 'Course Name',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, course_name: e.target.value })}
        />
      )
    },
    {
      key: 'course_code',
      dataIndex: 'course_code',
      title: 'Course Code',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, course_code: e.target.value })}
        />
      )
    },
    {
      key: 'section',
      dataIndex: 'section',
      title: 'Section',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, section: getAsNumber(e.target.value) })}
        />
      )
    },
    {
      key: 'score',
      dataIndex: 'score',
      title: 'Score',
      render: (value, row) => (
        <InputNumber
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, score: e })}
        />
      )
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments(Need head approval document)',
      render: (fileList, row) => (
        <Space>
          <FileUpload fileList={fileList} row={row} action={action} disabled={status === 1 || status === 2 || status === 3} status={status} />

          <AttachmentImageViewModal
            row={row}
            parentKey="attachment"
            title="Course Attachments"
          // status={status}
          />
        </Space>
      )
    }
  ];
};
